/**
 * @param onSubmit {(form: HTMLFormElement) => void}
 * @return {void}
 */
module.exports = function listenToRoiGateFormSubmission(onSubmit) {
    document.querySelectorAll('[data-component="roi-calculator-gate-form"]').forEach(form => {
        form.onsubmit = (e) => {
            e.preventDefault();
            onSubmit(e.currentTarget);
        };
    });
}